export const SUPPORTED_LANGS = ['en-US', 'it-IT', 'nl-NL', 'tr-TR', 'es-ES', 'fr-FR', 'de-DE', 'pt-PT'];

export const ROUTE_PREFIXES: Record<string, string> = {
  en: 'en-US',
  it: 'it-IT',
  nl: 'nl-NL',
  es: 'es-ES',
  tr: 'tr-TR',
  fr: 'fr-FR',
  de: 'de-DE',
  pt: 'pt-PT',
};

export function isEnglishOnlyRoute(path: string) {
  return (
    // Auth & protected routes
    path.startsWith('/admin') ||
    path.startsWith('/for-partners') ||
    path.startsWith('/for-suppliers') ||
    path.startsWith('/supplier') ||
    path.startsWith('/partner') ||
    path.startsWith('/guest') ||
    path.startsWith('/trips') ||
    path.startsWith('/auth') ||
    path.startsWith('/api') ||
    path === '/pay' ||
    path.startsWith('/pay/') ||
    // Public pages that should NOT have locale prefixes (they serve all languages)
    path === '/explore' ||
    path === '/search' ||
    path === '/destinations' ||
    path === '/attractions' ||
    path.startsWith('/legal/') ||
    path === '/legal'
  );
}

export function getBaseAndPrefix(path: string) {
  let prefix = '';
  let base = path;
  const lowerPath = path.toLowerCase();

  // Find if path starts with a supported lang prefix case-insensitively
  for (const p of SUPPORTED_LANGS) {
    const lowerP = p.toLowerCase();
    if (lowerPath.startsWith(`/${lowerP}/`) || lowerPath === `/${lowerP}`) {
      prefix = p;
      base = path.substring(lowerP.length + 1) || '/';
      if (!base.startsWith('/')) {
        base = '/' + base;
      }
      return { prefix, base };
    }
  }

  return { prefix, base };
}

export function stripAllLanguagePrefixes(path: string): string {
  let current = path;
  let found = true;
  while (found) {
    found = false;
    const { prefix, base } = getBaseAndPrefix(current);
    if (prefix) {
      current = base;
      found = true;
    }
  }
  return current;
}
